module.exports = "mat-list-item:hover\r\n{\r\n    background-color: #f5f5f5;\r\n}\r\n\r\n\r\nmat-icon[matSuffix]:hover\r\n{\r\n    cursor: pointer;\r\n}"